// extracted by mini-css-extract-plugin
export var menuItem = "B_vh d_fZ d_bz d_bD d_bP d_bf";
export var menuItemSub = "B_vj d_Z d_bz d_bP";
export var menuMainLink = "B_vk d_f0 d_dB";
export var menuLink = "B_vl d_f0 d_dB";
export var icon = "B_qK d_bC d_bP";
export var divider = "B_vm d_bC d_bP";
export var sublinks = "B_vn";
export var link = "B_mC";
export var Link = "B_tQ z_tQ z_s2 z_tm";